import { Component, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges } from '@angular/core';
import { PCTableInputModel, PCTableOutputModel } from '../../models/pc-table-input-model';
import { DatePipe } from '@angular/common';
import {CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-pctable-stock',
  templateUrl: './pctable-stock.component.html',
  providers: [DatePipe],
  styleUrls: ['./pctable-stock.component.css']
})
export class PctableStockComponent implements OnChanges {

  constructor(private renderer: Renderer2) {

    this.renderer.listen('window', 'keyup', (e: any) => {

      if (e.key == "ArrowUp" && this.focusRow > 0) {
        this.focusRow--;
      }

      if (e.key == "ArrowDown" && this.data?.data.length > this.focusRow) {
        this.focusRow++;
      }

    });
  }

  @Input() data?: PCTableInputModel;
  @Input() datetime?: any;
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public tableHeader!: any[];
  public focusRow: number = -1;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['data'] && changes['data'].currentValue !== undefined) {
      const newData = changes['data'].currentValue;

      if (newData && newData.data) {
        const data = newData.data;

        if (data != null && data.length > 0) {
          this.tableHeader = Object.keys(data[0])
          .filter(
            (current) =>
              current.toLowerCase() !== 'id' 
            && !current.includes('Id')
            && !current.includes('selected')
            && !current.includes('drugPackageCount')
          );
        }
      }
    }
  }

  callParent(element: any, action: string) {
    this.parentAction.next(new PCTableOutputModel(action, element));
  }

  drugIsExpire(date) {
    return (new Date()>=new Date(date));
   }

   checkBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }

  setBooleanClass(value: any): string {
    if (value) {
      return `bx bx-check-circle`
    }else{
      return `bx bx-x-circle`;
    }
  }

  drop(event) {
    moveItemInArray(this.tableHeader, event.previousIndex, event.currentIndex);
    var test='';
  }

}

